import "./heartproductscontainer.css";
import Heartproduct from "./heartproduct";
import { useProducts } from "../../context/ProductsContext"; // ✅ تعديل الاستيراد
import { useTranslation } from '../../hooks/useTranslation';

export default function Heartproductscontainer({ wishlist, setWishlist }) {
    const { productsdata } = useProducts(); // ✅ الحصول على البيانات من API
    const { t } = useTranslation();

    const filteredProducts = productsdata.filter(product =>
        wishlist && wishlist.includes(product.id)
    );

    if (filteredProducts.length === 0) {
        return (
            <div className="heart-product-container">
                <div className="container">
                    <div className="no-favorites-message">
                        <h3>{t('emptyWishlist')}</h3>
                        <p>{t('addToWishlistMessage')}</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="heart-product-container">
            <div className="container">
                <div className="heart-products-container">
                    {filteredProducts.map(product => (
                        <Heartproduct
                            key={product.id}
                            data={product}
                            wishlist={wishlist}
                            setWishlist={setWishlist}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}